'use client';

import React from 'react';
import styles from './NepaliDate.module.css';
import Image from 'next/image';
import { NepaliDate } from '@zener/nepali-datepicker-react';


export function NepaliDateCard() {
  const date = new NepaliDate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.leftSection}>
          <div className={styles.dateRow}>
            <span className={styles.day}>{date.getDate('np')}</span>
            <span className={styles.text}>
              {date.getMonthName('np')}, {date.getFullYear('np')} {date.getDayNameFull('np')}
            </span>
          </div>
        </div>

        <div className={styles.languageBadge}>
          <Image src="/images/smarten_.png" alt="Smarten" width={50} height={40} />
        </div>
      </div>
    </div>
  );
};


